var map = {
	"./defipulse.png": 414,
	"./discord.svg": 415,
	"./discord_white.svg": 248,
	"./gitbook.svg": 416,
	"./github.svg": 417,
	"./medium.svg": 418,
	"./telegram.svg": 419,
	"./twitter.svg": 420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 890;